module.exports = __webpack_public_path__ + "static/logo28-9a0646faed5a056fa7d235a02b95d382.png";